import * as tslib_1 from "tslib";
import { lazyPinLikeSurfaceAction } from 'owa-surface-actions-option';
export default function pinLikeSurfaceAction() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var pinLikeSurfaceAction;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, lazyPinLikeSurfaceAction.import()];
                case 1:
                    pinLikeSurfaceAction = _a.sent();
                    pinLikeSurfaceAction();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=pinLikeSurfaceAction.js.map